var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'jsx-dom';
import { listen, memoize } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPPluginButton } from '../../core/button/plugin-button';
import './dir-toggle.shape';
/** Text direction switcher button-plugin for UI Playground widget */
export class UIPDirSwitcher extends UIPPluginButton {
    get $preview() {
        return this.$root.querySelector('uip-preview');
    }
    get $content() {
        const type = this.constructor;
        return (React.createElement("div", { class: type.is + '-figure' },
            React.createElement("span", null, "L"),
            React.createElement("span", null, "T"),
            React.createElement("span", null, "R")));
    }
    get $label() {
        const type = this.constructor;
        return (React.createElement("div", { class: type.is + '-label' }, this.label || this.title));
    }
    connectedCallback() {
        if (!this.$root || !this.$preview)
            return;
        this.$$attr('uip-settings-content', true);
        this.$$fire('uip:settings:invalidate');
        super.connectedCallback();
        this.appendChild(this.$label);
        this.appendChild(this.$content);
        this.onDirChange();
    }
    attributeChangedCallback(attrName, oldVal, newVal) {
        super.attributeChangedCallback(attrName, oldVal, newVal);
        if (attrName === 'label')
            this.$label.textContent = this.label || this.title;
    }
    onAction() {
        if (!this.$preview)
            return;
        this.$preview.dir = this.$content.dir === 'rtl' ? 'ltr' : 'rtl';
    }
    onDirChange() {
        this.$content.dir = this.$preview.dir;
    }
}
UIPDirSwitcher.is = 'uip-dir-toggle';
UIPDirSwitcher.defaultTitle = 'Switch direction';
__decorate([
    memoize()
], UIPDirSwitcher.prototype, "$preview", null);
__decorate([
    memoize()
], UIPDirSwitcher.prototype, "$content", null);
__decorate([
    memoize()
], UIPDirSwitcher.prototype, "$label", null);
__decorate([
    listen({
        event: 'uip:dirchange',
        target: ($this) => $this.$preview,
    })
], UIPDirSwitcher.prototype, "onDirChange", null);
